import { ref } from 'vue'
import axios from 'axios'
import { loading } from '../utils/loading'
import { tokenInvalid } from '../utils/nativeAPI'
import { useUserStore } from '../stores/user'
import { showToast } from 'vant'
import { objKeySort, deleteNullKey } from '../utils/common'
import md5 from 'js-md5'
import qs from 'qs'
const instance = axios.create()
// instance.defaults.headers.post['Content-Type'] =
//   'application/json;charset=UTF-8'
instance.defaults.baseURL = import.meta.env.VITE_APP_API_BASE_URL
instance.defaults.withCredentials = false
instance.defaults.timeout = 30000
const count = ref(0)
let timmer: number = -1

function hideLoading() {
  timmer = window.setTimeout(() => {
    if (count.value === 0) {
      loading.hide()
    }
  }, 16)
}

function setRequestCount() {
  if (count.value > 0) {
    count.value--
  } else {
    count.value = 0
  }
  hideLoading()
}
const signKey = import.meta.env.VITE_APP_API_SIGN

instance.interceptors.request.use((config: any) => {
  const { header } = useUserStore()
  if (config.loadingShow === '1') {
    clearTimeout(timmer)
    loading.show()
    count.value++
  }
  config.headers.Accept = 'application/json'
  // const token = window.sessionStorage.getItem('token')
  // if (token) {
  //   config.headers.token = token
  //   config.headers.AuthToken = token
  //   config.headers.sysCode = header.sysCode || 'APP'
  //   config.headers.language = 'CN'
  // }
  config.headers = {
    ...config.headers,
    ...header
  }
  let data: any = ''
  /* 验签兼容get请求 */
  if (config.method === 'get' && config.url.indexOf('?') > 0) {
    data = qs.parse(config.url.split('?')[1])
    config.params = data || {}
  }
  const _time = new Date().getTime()
  config.headers.ts = _time
  console.log(signKey)
  let params = deleteNullKey(config.data)
  params = objKeySort(params)
  const reg = new RegExp('"', 'g')
  const key =
    `${JSON.stringify(params)}&ts=${_time}&signKey=${signKey}`.replace(reg, '')
  const md5UpperCase = md5(key).toUpperCase()
  console.log(md5UpperCase)
  config.headers.tmpSign = md5UpperCase
  config.headers.language = header.language.toUpperCase()
  return config
})

instance.interceptors.response.use(
  async (res) => {
    if (res.config?.loadingShow === '1') {
      setRequestCount()
    }
    const { code, msg } = res.data
    if (
      code == 40001 ||
      code == 40002 ||
      code == 40011 ||
      code == 40021 ||
      code == 40003 ||
      code == 40010
    ) {
      showToast(msg)
      setTimeout(() => {
        tokenInvalid(code)
      }, 500)
    }

    return Promise.resolve(res.data || {})
  },
  (error) => {
    count.value = 0
    hideLoading()

    return Promise.resolve(error || {})
  }
)

export default instance
